import { Controller } from "stimulus"

export default class extends Controller {
  static values = { delay: Number }

  connect() {
    const delay = this.hasDelayValue ? this.delayValue : 5000
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, delay)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    this.element.classList.add('animate__fadeOut')
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
